import React, { useMemo } from 'react';
import PresenceStatusBadge from './PresenceStatusBadge';

function PresenceStatsBar({ stats = {} }) {
  const { online = 0, idle = 0, offline = 0, recent = 0 } = stats;

  const total = useMemo(() => online + idle + offline, [online, idle, offline]);

  return (
    <div className="card mb-3">
      <div className="card-body d-flex flex-wrap gap-3 align-items-center">
        <div className="d-flex align-items-center">
          <PresenceStatusBadge status="online" />
          <strong className="me-1">Online:</strong> {online}
        </div>
        <div className="d-flex align-items-center">
          <PresenceStatusBadge status="idle" />
          <strong className="me-1">Idle:</strong> {idle}
        </div>
        <div className="d-flex align-items-center">
          <PresenceStatusBadge status="offline" />
          <strong className="me-1">Offline:</strong> {offline}
        </div>
        <div className="ms-auto text-muted small">
          Total tracked: {total} · Active last 5m: {recent}
        </div>
      </div>
    </div>
  );
}

export default PresenceStatsBar;
